exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__FieldThumbnail__fieldThumbnail__aU9I1 {\n  -webkit-transform: rotateX(180deg);\n          transform: rotateX(180deg);\n}", ""]);

// exports
exports.locals = {
	"fieldThumbnail": "dmb-web__FieldThumbnail__fieldThumbnail__aU9I1"
};